<template>
  <div class="navbar flex_bet">

    <bread-crum></bread-crum>

    <div class="right-menu flex_row flex_align_center">
      <template v-if="device!=='mobile'">
        <screen-icon class="right-menu-item hover-effect" />
        <lang-select class="right-menu-item hover-effect" />
        <map-menu class="right-menu-item hover-effect"></map-menu>
        <temp-unit class="right-menu-item hover-effect"></temp-unit>
      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <span>{{ company.companyName }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          
          <el-link :underline="false" class="dropdownP" @click="remarkOpen">{{ $t('company.Feedback') }}</el-link>
          <el-link :underline="false" v-if="userInfo.guestFlag!=true" class="dropdownP"
            @click="setUser">{{ $t('company.AccountSettings') }}</el-link>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">{{ $t('login.logOut') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="right-menu-item">
        v{{version}}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '../../../../package.json'

import LangSelect from '@/components/LangSelect'

import ScreenIcon from './ScreenIcon.vue'
import TempUnit from './TempUnit.vue'
import BreadCrum from './BreadCrum.vue'
import MapMenu from './MapMenu.vue'

export default {
  components: {
    ScreenIcon,
    LangSelect,
    TempUnit,
    BreadCrum,
    MapMenu
  },
  data () {
    return {
      version: config.version,
      isLogo: true,
      companyName: ''
    }
  },
  computed: {
    ...mapState(['device', 'avatar', 'sidebar', 'userInfo', 'company'])
  },
  mounted () {
    this.isLogo = false
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
    async logout () {
      await this.$store.dispatch('logout').then(res => {
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      }).catch(err => {
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      })
      
    },
    remarkOpen () {
      this.$emit('remarkOpenPop')
    },
    setUser () {
      this.$emit('setUserPop')
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dropdown-menu li {
  // margin-top:-7px!important;
  background: #e6ebf5;
  height: 42px;
  line-height: 36px;
}
.dropdownP {
  line-height: 30px;
  height: 30px;
  padding: 0 17px;
  font-size: 14px;
  color: #606266;
}
.navbar {
  width: 100%;
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  // box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  // .breadcrumb-container {
  //   float: left;
  // }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      padding: 0 8px;
      font-size: 18px;
      color: #5a5e66;
      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }
  }
}
</style>
